import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import { Heading, Stack, textVariants, Text } from '@etg/wings';

const baggageHeadingStyles = (isResultCardBaggageEnabled: boolean) => css`
  font-size: ${isResultCardBaggageEnabled ? '1.125rem' : 'initial'};

  @media ${mediaQueries.small.only} {
    font-size: 1rem;
  }
`;

const baggageSubTitleStyles = (isResultCardBaggageEnabled: boolean) => css`
  padding-bottom: ${isResultCardBaggageEnabled ? '16px' : '8px'};
`;

interface BaggageInformationTitleProps {
  isResultCardBaggageEnabled?: boolean;
}

const BaggageInformationTitle = ({
  isResultCardBaggageEnabled = false,
}: BaggageInformationTitleProps) => {
  const { t } = useTranslation();

  return (
    <Stack aria-labelledby="baggage-heading per-person-text" as="h4" spacing={4}>
      <Heading
        aria-hidden
        as="span"
        className={baggageHeadingStyles(isResultCardBaggageEnabled)}
        id="baggage-heading"
        level={4}
      >
        {t('Result.Baggage.Header.Text')}
      </Heading>
      <Text
        aria-hidden
        className={baggageSubTitleStyles(isResultCardBaggageEnabled)}
        id="per-person-text"
        variant={textVariants._12}
      >
        {t('Result.Baggage.PerPerson.Text')}
      </Text>
    </Stack>
  );
};

export default BaggageInformationTitle;
